import React, { useMemo } from 'react';
import createTheme from '@mui/material/styles/createTheme';
import MuiThemeProvider from '@mui/material/styles/ThemeProvider';
import { deepmerge } from '@mui/utils';
import { mainTheme } from '../MaterialUi/ThemeProviderMain';


// Theme for forms on dark blue background

const contactTheme = createTheme( 

    deepmerge(mainTheme, {

        id: 'contactTheme',

        // palette: {
        //     mode: 'dark',
        //     primary: { main: '#ffffff' },
        //     // secondary: { main: '#a9bf00', contrastText: '#fff' },
        //     secondary: { main: '#e40051', contrastText: '#fff' },
        //     tertiary: { main: '#a9bf00', contrastText: '#fff' },
        // },
        components: {
        // open select: use a light theme
            MuiMenu: {
                styleOverrides: {
                    list: {
                        backgroundColor: "#f2f2f2",
                    }
                }
            },
            MuiInputBase: {
                styleOverrides: {
                    root: {
                        margin: '0',
                        backgroundColor: "#ffffff20",
                        // '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        //     borderColor: '#f00',

                        // },
                    },
                    input: {
                        height: 'auto',
                        '&:focus': {
                            boxShadow: 'none'
                        },
                        // "& .Mui-focused": {
                        //     borderColor: '#f00',
                        // },
                        // '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
                        //     borderColor: '#f00',

                        // },
                    },
                   
                },
            },
            MuiFormControl: {
                styleOverrides: {
                    root: {
                        marginBottom: '1rem',

                        '& .MuiFormLabel-root': {
                            color: '#fff',
                            "&.Mui-focused": {
                                color: '#fff',
                            },
                        },
                        '& .MuiOutlinedInput-notchedOutline': {
                            // borderColor: '#f00',
                            // "&.Mui-focused": {
                            //     borderColor: '#f00',
                            // },
                        },
                        // '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                        //     borderColor: '#f00',

                        // },
                    },
                    // label: {
                    //     color: '#000',
                    //     "&.Mui-focused": {
                    //         color: '#f00',
                    //     },
                    // }
                },
            },
            MuiMenuItem: {
                styleOverrides: {
                    root: {
                        backgroundColor: "#f2f2f2",
                        color: '#000',
                        "&:hover": {
                            backgroundColor: "#ddd",
                        },
                    },
                },
            },
            // MuiButton: {
            //     styleOverrides: {
            //         root: {
            //             padding: '10px 25px',
            //             fontWeight: 600
            //         },
            //     },
            // },
        },
    })
);



export interface IThemeProviderProps { }

const ContactThemeProvider: React.FC<React.PropsWithChildren<IThemeProviderProps>> = ({ children }) => {

    const MemoizedThemeProvider = useMemo(() => {
        return MuiThemeProvider;
    }, []);

    return (
        <div>
            <MemoizedThemeProvider theme={contactTheme}>{children}</MemoizedThemeProvider>
        </div>
    );
};

export default ContactThemeProvider;
